import React from 'react';
import Icon from 'components/AppIcon';

export default function RecentActivityPanel({ activities, announcements }) {
  const iconMap = {
    registration: { icon: 'UserCheck', color: 'text-success', bg: 'bg-green-50' },
    enrollment: { icon: 'BookMarked', color: 'text-primary', bg: 'bg-blue-50' },
    completion: { icon: 'CheckCircle2', color: 'text-success', bg: 'bg-green-50' },
    update: { icon: 'Pencil', color: 'text-warning', bg: 'bg-amber-50' },
  };

  return (
    <div className="space-y-4">
      {/* Announcements */}
      <div className="bg-card border border-border rounded-xl p-5 shadow-sm">
        <h2 className="text-base font-heading font-semibold text-foreground flex items-center gap-2 mb-4">
          <Icon name="Megaphone" size={17} color="var(--color-accent)" />
          Announcements
        </h2>
        <div className="space-y-3">
          {announcements?.map((ann) => (
            <div key={ann?.id} className="flex gap-3 p-3 bg-muted rounded-lg">
              <div className="w-2 h-2 rounded-full bg-accent mt-1.5 flex-shrink-0" />
              <div className="min-w-0">
                <p className="text-sm font-caption font-medium text-foreground">{ann?.title}</p>
                <p className="text-xs font-caption text-muted-foreground mt-0.5 line-clamp-2">{ann?.message}</p>
                <p className="text-xs font-caption text-muted-foreground mt-1">{ann?.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Recent Activity */}
      <div className="bg-card border border-border rounded-xl p-5 shadow-sm">
        <h2 className="text-base font-heading font-semibold text-foreground flex items-center gap-2 mb-4">
          <Icon name="Activity" size={17} color="var(--color-primary)" />
          Recent Activity
        </h2>
        <div className="space-y-3">
          {activities?.map((act) => {
            const cfg = iconMap?.[act?.type] || iconMap?.update;
            return (
              <div key={act?.id} className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-full ${cfg?.bg} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={cfg?.icon} size={15} color="currentColor" className={cfg?.color} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-caption text-foreground">{act?.description}</p>
                  <p className="text-xs font-caption text-muted-foreground mt-0.5">{act?.time}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Upcoming Sessions */}
      <div className="bg-card border border-border rounded-xl p-5 shadow-sm">
        <h2 className="text-base font-heading font-semibold text-foreground flex items-center gap-2 mb-4">
          <Icon name="CalendarClock" size={17} color="var(--color-primary)" />
          Upcoming Sessions
        </h2>
        <div className="space-y-3">
          <div className="flex items-center gap-3 p-3 border border-blue-200 bg-blue-50 rounded-lg">
            <div className="text-center flex-shrink-0 w-10">
              <p className="text-xs font-caption text-blue-600 font-semibold">MAR</p>
              <p className="text-lg font-heading font-bold text-blue-700 leading-none">10</p>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-caption font-medium text-foreground">Volunteer Orientation</p>
              <p className="text-xs font-caption text-muted-foreground">10:00 AM – 12:00 PM · Online</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 border border-border bg-muted rounded-lg">
            <div className="text-center flex-shrink-0 w-10">
              <p className="text-xs font-caption text-muted-foreground font-semibold">MAR</p>
              <p className="text-lg font-heading font-bold text-foreground leading-none">18</p>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-caption font-medium text-foreground">First Aid Basics</p>
              <p className="text-xs font-caption text-muted-foreground">2:00 PM – 4:00 PM · Room 3B</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}